
export interface GoogleAdsApiRetryDelayGq {
  id: number;
  issuedAtTime: string;
  retryAtTime: string;
}

export const GoogleAdsApiRetryDelayGqProps = `
  id  
  issuedAtTime
  retryAtTime
`;
